module.exports = __webpack_public_path__ + "static/media/world.6f8320fd.svg";